import { Card, Col, Row } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { useQuery } from "@tanstack/react-query";
import nodeApi from "../lib/api";

function Dashboard() {
  const {
    data: outgoingData,
    isLoading: isOutgoingLoading,
    isError: isOutgoingError,
  } = useQuery({
    queryKey: ["outgoing"],
    queryFn: () => nodeApi.get("/report/outgoing").then((res) => res.data),
  });

  const {
    data: incomingData,
    isLoading: isIncomingLoading,
    isError: isIncomingError,
  } = useQuery({
    queryKey: ["incoming"],
    queryFn: () => nodeApi.get("/report/incoming").then((res) => res.data),
  });

  const totalSent = (outgoingData || []).reduce((total, challan) => {
    const itemsTotal = (challan?.outgoing_items || []).reduce(
      (sum, item) => sum + (item?.quantity || 0),
      0
    );
    return total + itemsTotal;
  }, 0);

  const totalReturned = (incomingData || []).reduce((total, challan) => {
    const itemsTotal = (challan?.incoming_items || []).reduce(
      (sum, item) => sum + (item?.quantity || 0),
      0
    );
    return total + itemsTotal;
  }, 0);

  const pendingQuantity = Math.abs(totalSent - totalReturned);

  // Use the loading states from the queries
  if (isOutgoingLoading || isIncomingLoading) {
    return (
      <div>
        <Navbar />
        <div className="d-flex">
          <Sidebar />
          <div className="container-fluid p-4">
            <h5 className="w-100 h-100 d-flex justify-content-center align-items-center">
              Loading Dashboard...
            </h5>
          </div>
        </div>
      </div>
    );
  }

  if (isOutgoingError || isIncomingError) {
    return (
      <div>
        <Navbar />
        <div className="d-flex">
          <Sidebar />
          <div className="container-fluid p-4">
            <h5 className="w-100 h-100 d-flex justify-content-center align-items-center text-danger">
              Error loading dashboard data.
            </h5>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <div className="d-flex">
        <Sidebar />
        <div className="container-fluid p-4">
          <h4 className="mb-4 fw-bold">Dashboard</h4>
          <h5 className="fw-bold mb-3">Challan Summary</h5>
          <Row className="g-4">
            <Col md={4}>
              <Card
                className="shadow"
                style={{ height: "140px", backgroundColor: "#0d6efd" }}
              >
                <Card.Body className="d-flex flex-column justify-content-center text-white">
                  <h6 className="fw-semibold mb-2">Total Quantity Sent</h6>
                  <h3 className="fw-bold">{totalSent}</h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card
                className="shadow"
                style={{ height: "140px", backgroundColor: "#198754" }}
              >
                <Card.Body className="d-flex flex-column justify-content-center text-white">
                  <h6 className="fw-semibold mb-2">Total Quantity Returned</h6>
                  <h3 className="fw-bold">{totalReturned}</h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card
                className="shadow"
                style={{ height: "140px", backgroundColor: "#ffc107" }}
              >
                <Card.Body className="d-flex flex-column justify-content-center text-dark">
                  <h6 className="fw-semibold mb-2">Pending Quantity</h6>
                  <h3 className="fw-bold">{pendingQuantity}</h3>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
